import { PaymentInfo, PaymentInfoDTO } from "@/models/payment-info.model";
import apiClient from "./apiClient";
import { getUTCDate } from "@/utils/date-format";

export async function getPaymentInfoByUserId(
  userId: number
): Promise<PaymentInfoDTO> {
  const res = await apiClient.get(`/users/${userId}/payment-info`);
  const data: PaymentInfoDTO = res.data as PaymentInfoDTO;
  return data;
}

export async function updatePaymentInfoByPaymentInfoId(
  id: number,
  args: {
    basicSalary?: number;
    cpfType?: string;
    cpfSection?: string;
    employerCpfContributionRate?: number;
    employeeCpfContributionRate?: number;
    selfHelpGroup?: string;
    bankName?: string;
    bankCode?: string;
    branchCode?: string;
    accountNo?: string;
  }
): Promise<PaymentInfoDTO> {
  try {
    const res = await apiClient.patch(`/payment-info/${id}`, {
      ...args,
    });
    const data: PaymentInfoDTO = res.data as PaymentInfoDTO;
    return data;
  } catch (error) {
    console.log(error);
    return {} as PaymentInfoDTO;
  }
}
